import { render, staticRenderFns } from "./discountDetails.vue?vue&type=template&id=75821e86"
import script from "./discountDetails.vue?vue&type=script&lang=js"
export * from "./discountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports